import FuxHTTP from "../../lib/FuxFramework/FuxHTTP";
import APIConfig from "../APIConfig";
import AuthAPI from "../AuthAPI";

export const _Staff = {
    list: () => {
        return FuxHTTP.apiGetRequestWithPromise(
            APIConfig.url("/modulo-hr/get-staff-list"),
            {
                token: AuthAPI.currentUser.accessToken
            },
            FuxHTTP.RESOLVE_DATA,
            FuxHTTP.REJECT_MESSAGE
        );
    }
};
